const LinkedinIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.25875 5.64814H4.18375V14.8002H1.25875V5.64814ZM11.7325 5.3454C10.45 5.3454 9.685 5.83444 8.875 6.90567V5.64814H5.95V14.8002H8.8975V9.83992C8.8975 8.79198 9.415 7.76732 10.585 7.76732C11.755 7.76732 12.4525 8.79198 12.4525 9.81663V14.8002H15.4V9.60705C15.4 5.99746 13.0375 5.3454 11.7325 5.3454ZM2.7325 1.2002C1.765 1.2002 1 1.92211 1 2.80704C1 3.69198 1.765 4.41389 2.7325 4.41389C3.7 4.41389 4.465 3.69198 4.465 2.80704C4.465 1.92211 3.7 1.2002 2.7325 1.2002Z"
      fill="currentColor"
    />
  </svg>
);

export { LinkedinIcon };
